const rules = {
  required: "Field is required",
  email: "The email is invalid",
  postalCode: "Field must be 5 characters in length",
  integer: "Only integer are valid",
};
export default rules;
